import { useEffect } from 'react';

export function useTimeout(callback, delay) {
  useEffect(() => {
    if (delay === null) return;

    const timeout = setTimeout(callback, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [callback, delay]);
};
